import API from './base';

class AnnonceApi extends API {
  postAnswer = (id, answer) => this.post(`/api/web/v1/announces/${id}/announces_answers`, answer);
}

export default new AnnonceApi();
